import React, { useState } from "react";
import axios from "axios";
import { Apiurl } from "../../../shared/services/apirest";
import { getAuthHeader } from "../utils/investigadorUtils";

const BuscarPaciente = ({ setView, setSelectedPaciente, showToast, activeProjectId }) => {
    const [search, setSearch] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSearch = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.get(`${Apiurl}casos/pacientes/`, getAuthHeader());
            let data = res.data;
            if (activeProjectId) {
                data = data.filter(p => p.proyecto === activeProjectId);
            }
            const filtered = data.filter(p =>
                p.nombre.toLowerCase().includes(search.toLowerCase()) ||
                p.documento.includes(search)
            );
            setResults(filtered);
        } catch (err) {
            showToast("Error buscando pacientes.", "danger");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="table-container p-4">
            <h5 className="fw-bold text-success mb-4">Buscar Paciente para Nuevo Caso</h5>
            <form onSubmit={handleSearch} className="d-flex gap-2 mb-4">
                <input
                    className="form-control"
                    placeholder="Nombre o Documento..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <button type="submit" className="btn btn-success">
                    {loading ? <span className="spinner-border spinner-border-sm"></span> : "Buscar"}
                </button>
            </form>

            <div className="table-responsive">
                <table className="table table-hover align-middle admin-table">
                    <thead>
                        <tr>
                            <th>Documento</th>
                            <th>Nombre</th>
                            <th>Municipio</th>
                            <th>Proyecto</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.map(p => (
                            <tr key={p.id}>
                                <td>{p.documento}</td>
                                <td>{p.nombre}</td>
                                <td>{p.municipio}</td>
                                <td><span className="badge bg-light text-success border-success" style={{ fontSize: '0.65rem' }}>{p.codigo_proyecto_investigacion || "N/A"}</span></td>
                                <td>
                                    <button className="btn btn-sm btn-outline-success" onClick={() => {
                                        setSelectedPaciente(p);
                                        setView("registrarCaso");
                                    }}>
                                        Seleccionar
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BuscarPaciente;
